type Errors = { [key: string]: string };

const validateMandatory = (field: string, value: any, errors: Errors) => {
  if (!value) {
    return { ...errors, [field]: "Mandatory field" };
  }
  return errors;
};

const validateLength = (
  field: string,
  value: string,
  maxLength: number,
  errors: Errors
) => {
  if (value && value.length > maxLength) {
    return {
      ...errors,
      [field]: `${capitalize(
        field
      )} should contain only ${maxLength} characters`,
    };
  }
  return { ...errors, [field]: "" };
};

const validateEmail = (value: string, errors: Errors) => {
  const email = value.trim();
  const regex = /^[a-zA-Z0-9._%+-]+@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[A-Za-z]{2,}$/;
  if (!email) return { ...errors, emailID: "Mandatory field" };
  if (!regex.test(email)) return { ...errors, emailID: "Enter a valid email" };
  return { ...errors, emailID: "" };
};

const validatePhone = (value: string, errors: Errors) => {
  const regex = /^\d{10}$/;
  if (!value) return { ...errors, contactNumber: "Mandatory field" };
  if (!regex.test(value))
    return { ...errors, contactNumber: "Enter a valid 10-digit number" };
  return { ...errors, contactNumber: "" };
};

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export const validateFormField = (name: string, value: any, setErrors: any) => {
  setErrors((prev: Errors) => {
    let updatedErrors = { ...prev };
    switch (name) {
      case "firstName":
      case "lastName":
        updatedErrors = validateMandatory(name, value, updatedErrors);
        if (value)
          updatedErrors = validateLength(name, value, 50, updatedErrors);
        break;
      case "securityGroupId":
      case "countryCode":
        updatedErrors = validateMandatory(name, value, updatedErrors);
        if (value) updatedErrors = { ...updatedErrors, [name]: "" };
        break;
      case "emailID":
        updatedErrors = validateEmail(value, updatedErrors);
        break;
      case "contactNumber":
        updatedErrors = validatePhone(value, updatedErrors);
        break;
      default:
        break;
    }
    return updatedErrors;
  });
};
